// import React from 'react';
// import { Table, Text, Loader, Center } from '@mantine/core';

// const UniversalTable = ({ 
//   headers, 
//   data, 
//   loading, 
//   emptyMessage = "No records found" 
// }) => {
//   return (
//     <div className="mt-6 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm ring-1 ring-black ring-opacity-5">
//       <div className="overflow-x-auto">
//         <Table 
//           verticalSpacing="sm" 
//           horizontalSpacing="lg" 
//           highlightOnHover 
//           withColumnBorders={false}
//           className="min-w-full divide-y divide-slate-200"
//         >
//           {/* Header section with refined typography */}
//           <thead className="bg-slate-50/80 backdrop-blur-sm sticky top-0 z-10">
//             <tr>
//               {headers.map((header, index) => (
//                 <th 
//                   key={index} 
//                   style={{ 
//                     color: '#64748b', // Slate 500
//                     fontSize: '12px', 
//                     fontWeight: 600, 
//                     textTransform: 'uppercase', 
//                     letterSpacing: '0.05em',
//                     textAlign: header.align || 'left',
//                     width: header.width || 'auto',
//                     paddingTop: '16px',
//                     paddingBottom: '16px',
//                     borderBottom: '1px solid #e2e8f0'
//                   }}
//                 >
//                   {header.label}
//                 </th>
//               ))}
//             </tr>
//           </thead>

//           {/* Table Body */}
//           <tbody className="divide-y divide-slate-100 bg-white">
//             {loading ? (
//               <tr>
//                 <td colSpan={headers.length}>
//                   <Center py={60}>
//                     <Loader size="md" variant="dots" color="#1b6f8d" />
//                   </Center>
//                 </td>
//               </tr>
//             ) : data?.length > 0 ? (
//               data.map((row, rowIndex) => (
//                 <tr 
//                   key={row.id || rowIndex} 
//                   className="group transition-all duration-200 hover:bg-blue-50/30"
//                 >
//                   {headers.map((header, colIndex) => (
//                     <td 
//                       key={colIndex} 
//                       style={{ 
//                         textAlign: header.align || 'left',
//                         paddingTop: '14px',
//                         paddingBottom: '14px'
//                       }}
//                       className="whitespace-nowrap"
//                     >
//                       {header.render ? (
//                         header.render(row, rowIndex)
//                       ) : (
//                         <Text size="sm" weight={500} className="text-slate-700">
//                           {row[header.key] ?? "--"}
//                         </Text>
//                       )}
//                     </td>
//                   ))}
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={headers.length} className="py-24 text-center">
//                   <div className="flex flex-col items-center justify-center">
//                     <Text size="sm" className="font-medium text-slate-400 italic">
//                       {emptyMessage}
//                     </Text>
//                   </div>
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       </div>
//     </div>
//   );
// };

// export default UniversalTable;

import React from 'react';
import { Table, Text, Loader, Center } from '@mantine/core';

const UniversalTable = ({ 
  headers, 
  data, 
  loading, 
  emptyMessage = "No records found" 
}) => {
  return (
    <div className="mt-6 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-shadow hover:shadow-md">
      <div className="overflow-x-auto">
        <Table 
          verticalSpacing="md"  // Increased for "Today's standard" look
          horizontalSpacing="lg" 
          highlightOnHover 
          className="min-w-full"
        >
          <thead className="bg-slate-50/80 border-b border-slate-200">
            <tr>
              {headers.map((header, index) => (
                <th 
                  key={index} 
                  style={{ 
                    textAlign: header.align || 'left',
                    width: header.width || 'auto',
                  }}
                  className="py-4 px-4" // Explicit padding to prevent label overlap
                >
                  <div 
                    className="text-[11px] font-bold uppercase tracking-wider text-slate-500 leading-tight"
                    style={{ textAlign: header.align || 'left' }}
                  >
                    {header.label}
                  </div>
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100">
            {loading ? (
              <tr>
                <td colSpan={headers.length}>
                  <Center py={80}>
                    <Loader size="sm" color="#1b6f8d" />
                  </Center>
                </td>
              </tr>
            ) : data?.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr 
                  key={row.id || rowIndex} 
                  className="transition-colors hover:bg-slate-50/50"
                >
                  {headers.map((header, colIndex) => (
                    <td 
                      key={colIndex} 
                      className="py-4 px-4"
                      style={{ textAlign: header.align || 'left' }}
                    >
                      {header.render ? (
                        header.render(row, rowIndex)
                      ) : (
                        <Text size="xs" weight={500} className="text-slate-700">
                          {row[header.key] ?? "--"}
                        </Text>
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers.length} className="py-20 text-center">
                  <Text size="sm" className="text-slate-400 font-medium italic">
                    {emptyMessage}
                  </Text>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default UniversalTable;